import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { Destination } from 'src/app/models/destination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { DestinationService } from 'src/app/services/destination.service';

@Component({
  selector: 'app-destinations',
  templateUrl: './destinations.component.html',
  styleUrls: ['./destinations.component.scss']
})
export class DestinationsComponent {
  showModalCreate = false;
  destinationName: string = null;
  loadingCreate = false;
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "Crear", "fa-save");
  
  destinations: Destination[] = [];
  destinationSelected: Destination = null;
  destinationSelectedId: number = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  filterWord: string = null;
  editDestination: { [key: number]: boolean } = {};
  loading = false;
  updatingActive: { [key: string]: boolean } = {};
  loadingUpdate: { [key: string]: boolean } = {};

  constructor(
    private destinationService: DestinationService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getDestinations();
  }

  getDestinations() {
    this.loading = true;
    this.destinationService.getDestinations().subscribe({
      next: (response: ResponseObject) => {
        this.destinations = response.data;
        this.pagination.filter = this.destinations;
        this.pagination.total = this.destinations;
        this.resetPagination();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener destinos.", "Error");
        this.loading = false
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  setDestinationSelected(destination: Destination) {
    this.destinationSelected = destination;
    this.destinationSelectedId = this.destinationSelected.id;
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    this.pagination.total = this.destinations.filter((list) => {
      const filter = this.filterWord.toLowerCase();

      return (
        list.name.toLowerCase().includes(filter) // búsqueda parcial por nombre
      );
    });

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  updateList(destination: Destination) {
    this.loadingUpdate[destination.id]=true;
    this.destinationService.updateDestination(destination.id, { name: destination.name }).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Destino actualizado correctamente.", "Exito");
        this.editDestination[destination.id] = false;
        this.loadingUpdate[destination.id] = false;
        this.getDestinations();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se actualizo el nombre del destino", "Error");
        this.editDestination[destination.id] = false;
        this.loadingUpdate[destination.id] = false;
      }
    });
  }

  setActiveDestination(destination: Destination){
    if (destination.active) {
      this.deleteList(destination);
    }else {
      this.activeList(destination);
    }
  }

  activeList(destination: Destination) {
    this.updatingActive[destination.id] = true;
    this.destinationService.updateActiveDestination(destination.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Destino Activado correctamente.", "Exito");
        // this.getDestinations();
        destination.active = true;
        this.updatingActive[destination.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pudo Activar el destino", "Error");
        this.updatingActive[destination.id] = false;
      }
    });
  }

  deleteList(destination: Destination) {
    this.updatingActive[destination.id] = true;
    this.destinationService.deleteDestination(destination.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Destino Desctivado correctamente.", "Exito");
        // this.getDestinations();
        destination.active = false;
        this.updatingActive[destination.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pudo Desctivar el destino", "Error");
        this.updatingActive[destination.id] = false;
      }
    });
  }

  editingName(destination: Destination) {
    if (this.editDestination[destination.id]) {
      this.editDestination[destination.id] = false;
      return;
    }
    this.editDestination[destination.id] = true;
  }

  openModal() {
    this.showModalCreate = true;
    this.destinationName = null;
  }

  closeModal(event: any) {
    this.showModalCreate = false;
    this.destinationName = null;
  }

  addList() {
    if (!this.destinationName) {
      return
    }
    let data = { name: this.destinationName }
    this.loadingCreate = true;
    this.destinationService.createDestination(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Destino agregada.", "Exito");
        this.loadingCreate = false;
        this.closeModal(true);
        this.getDestinations();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al agregar el destino.", "Error");
      }
    });

  }

}
